/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MetricType } from './MetricType';
import {
    MetricTypeFromJSON,
    MetricTypeFromJSONTyped,
    MetricTypeToJSON,
    MetricTypeToJSONTyped,
} from './MetricType';
import type { ScoringEventConfig } from './ScoringEventConfig';
import {
    ScoringEventConfigFromJSON,
    ScoringEventConfigFromJSONTyped,
    ScoringEventConfigToJSON,
    ScoringEventConfigToJSONTyped,
} from './ScoringEventConfig';

/**
 * 
 * @export
 * @interface IScoringConfig
 */
export interface IScoringConfig {
    /**
     * For FIRST_TO_WINS - number of wins needed
     * @type {number}
     * @memberof IScoringConfig
     */
    targetWins?: number;
    /**
     * 
     * @type {MetricType}
     * @memberof IScoringConfig
     */
    metricType?: MetricType;
    /**
     * For METRIC_THRESHOLD - target value to reach
     * @type {number}
     * @memberof IScoringConfig
     */
    targetValue?: number;
    /**
     * For TIME_BASED - max time allowed in milliseconds
     * @type {number}
     * @memberof IScoringConfig
     */
    timeLimit?: number;
    /**
     * For PLACEMENT - how many placement tiers to track
     * @type {number}
     * @memberof IScoringConfig
     */
    placementTiers?: number;
    /**
     * For CUSTOM - JSONata expression for scoring
     * @type {string}
     * @memberof IScoringConfig
     */
    customExpression?: string;
    /**
     * 
     * @type {Array<ScoringEventConfig>}
     * @memberof IScoringConfig
     */
    scoringEvents?: Array<ScoringEventConfig>;
}



/**
 * Check if a given object implements the IScoringConfig interface.
 */
export function instanceOfIScoringConfig(value: object): value is IScoringConfig {
    return true;
}

export function IScoringConfigFromJSON(json: any): IScoringConfig {
    return IScoringConfigFromJSONTyped(json, false);
}

export function IScoringConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): IScoringConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'targetWins': json['targetWins'] == null ? undefined : json['targetWins'],
        'metricType': json['metricType'] == null ? undefined : MetricTypeFromJSON(json['metricType']),
        'targetValue': json['targetValue'] == null ? undefined : json['targetValue'],
        'timeLimit': json['timeLimit'] == null ? undefined : json['timeLimit'],
        'placementTiers': json['placementTiers'] == null ? undefined : json['placementTiers'],
        'customExpression': json['customExpression'] == null ? undefined : json['customExpression'],
        'scoringEvents': json['scoringEvents'] == null ? undefined : ((json['scoringEvents'] as Array<any>).map(ScoringEventConfigFromJSON)),
    };
}

export function IScoringConfigToJSON(json: any): IScoringConfig {
    return IScoringConfigToJSONTyped(json, false);
}

export function IScoringConfigToJSONTyped(value?: IScoringConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'targetWins': value['targetWins'],
        'metricType': MetricTypeToJSON(value['metricType']),
        'targetValue': value['targetValue'],
        'timeLimit': value['timeLimit'],
        'placementTiers': value['placementTiers'],
        'customExpression': value['customExpression'],
        'scoringEvents': value['scoringEvents'] == null ? undefined : ((value['scoringEvents'] as Array<any>).map(ScoringEventConfigToJSON)),
    };
}

